import { goSolidApi } from "@/composables/useGoSolidApi";
import type { BookedCommissions } from "@/types";

export const getBookedCommissions = async (
  referrerIds: number[],
  dateFrom: Date | null,
  dateTo: Date | null
): Promise<BookedCommissions> => {
  const params = new URLSearchParams();
  params.set("referrer_ids", referrerIds.join(","));
  if (dateFrom) {
    params.set("date_from", dateFrom.toISOString());
  }
  if (dateTo) {
    params.set("date_to", dateTo.toISOString());
  }
  const response = await goSolidApi.get(
    `/api/admin/commission/booked?${params.toString()}`
  );
  return response.data.data;
};
